import { MESSAGES_COPY } from '../messages/COPY';
import { PLACEHOLDERS_COPY } from '../placeholders/COPY';

export const PASSWORD = {
	MAX_LENGTH: 32,
	MIN_LENGTH: 8,
	PATTERN: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}/u,
	PLACEHOLDER: PLACEHOLDERS_COPY.PASSWORD,
	PLACEHOLDER_CONFIRM: PLACEHOLDERS_COPY.CONFIRM_PASSWORD,
	PLACEHOLDER_CURRENT: PLACEHOLDERS_COPY.CURRENT_PASSWORD,
	PLACEHOLDER_NEW: PLACEHOLDERS_COPY.NEW_PASSWORD,
	REQUIRED_MESSAGE: MESSAGES_COPY.PLEASE_ENTER_PASSWORD,
	REQUIRED_MESSAGE_CONFIRM: MESSAGES_COPY.PLEASE_CONFIRM_PASSWORD,
	REQUIRED_MESSAGE_CURRENT: MESSAGES_COPY.PLEASE_ENTER_CURRENT_PASSWORD,
	REQUIRED_MESSAGE_NEW: MESSAGES_COPY.PLEASE_ENTER_NEW_PASSWORD,
	REQUIREMENT_LENGTH: '8 or More Characters',
	REQUIREMENT_LOWERCASE: '1 Lowercase',
	REQUIREMENT_NONALPHANUMERIC: '1 Non-Alphanumeric',
	REQUIREMENT_NUMERIC: '1 Number',
	REQUIREMENT_UPPERCASE: '1 Uppercase'
};
